/**
 * service
 */
import taskmanAxios from '../helpers/axios'
import { getAttachmentUploadErrorMessage, getAttachmentValidationMessage } from '../utils/attachmentValidation'
/**
 * const
 */
import {
    API_COMMENTS_CREATE_URL,
    API_MAKE_COMMENTS_BY_TASK_URL,
    API_MAKE_COMMENT_URL,
    API_MAKE_COMMENT_ATTACHMENTS_URL,
    API_MAKE_COMMENT_LIKE_URL,
} from "../constants/api.constant";

export default class CommentService {
    static async create(data: { task_id: number; content: string; parent_comment_id?: number }){
        return await taskmanAxios.post(API_COMMENTS_CREATE_URL, data)
            .then(response => response.data)
            .catch(e => Promise.reject(e));
    }

    static async listByTask(taskId: number){
        return await taskmanAxios.get(API_MAKE_COMMENTS_BY_TASK_URL(taskId))
            .then(response => response.data)
            .catch(e => Promise.reject(e));
    }

    static async get(commentId: number){
        return await taskmanAxios.get(API_MAKE_COMMENT_URL(commentId))
            .then(response => response.data)
            .catch(e => Promise.reject(e));
    }

    static async update(commentId: number, content: string, parentCommentId?: number | null){
        return await taskmanAxios.patch(API_MAKE_COMMENT_URL(commentId), {
            content,
            ...(parentCommentId ? { parent_comment_id: parentCommentId } : {}),
        })
            .then(response => response.data)
            .catch(e => Promise.reject(e));
    }

    static async delete(commentId: number){
        return await taskmanAxios.delete(API_MAKE_COMMENT_URL(commentId))
            .then(response => response.data)
            .catch(e => Promise.reject(e));
    }

    static async uploadAttachments(commentId: number, files: File[]){
        const validationError = getAttachmentValidationMessage(files)
        if (validationError) throw new Error(validationError)

        const form = new FormData()
        files.forEach((file) => form.append('files', file))
        return await taskmanAxios.post(API_MAKE_COMMENT_ATTACHMENTS_URL(commentId), form)
            .then(response => response.data)
            .catch(error => { throw new Error(getAttachmentUploadErrorMessage(error, files.map((file) => file.name).join(', '))) });
    }

    static async like(commentId: number){
        return await taskmanAxios.post(API_MAKE_COMMENT_LIKE_URL(commentId))
            .then(response => response.data)
            .catch(e => Promise.reject(e));
    }

    static async unlike(commentId: number){
        return await taskmanAxios.delete(API_MAKE_COMMENT_LIKE_URL(commentId))
            .then(response => response.data)
            .catch(e => Promise.reject(e));
    }
}
